export const IMAGE_MEDIA_TYPE = "image";
export const VIDEO_MEDIA_TYPE = "video";
